/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CategoryStatisticsDto from './CategoryStatisticsDto';

/**
 * The UserStatisticsDto model module.
 * @module model/UserStatisticsDto
 * @version v0
 */
class UserStatisticsDto {
    /**
     * Constructs a new <code>UserStatisticsDto</code>.
     * @alias module:model/UserStatisticsDto
     */
    constructor() { 
        
        UserStatisticsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserStatisticsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserStatisticsDto} obj Optional instance to populate.
     * @return {module:model/UserStatisticsDto} The populated <code>UserStatisticsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserStatisticsDto();

            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('totalSessions')) {
                obj['totalSessions'] = ApiClient.convertToType(data['totalSessions'], 'Number');
            }
            if (data.hasOwnProperty('completedSessions')) {
                obj['completedSessions'] = ApiClient.convertToType(data['completedSessions'], 'Number');
            }
            if (data.hasOwnProperty('activeSessions')) {
                obj['activeSessions'] = ApiClient.convertToType(data['activeSessions'], 'Number');
            }
            if (data.hasOwnProperty('totalPagesVisited')) {
                obj['totalPagesVisited'] = ApiClient.convertToType(data['totalPagesVisited'], 'Number');
            }
            if (data.hasOwnProperty('totalQuestionsAnswered')) {
                obj['totalQuestionsAnswered'] = ApiClient.convertToType(data['totalQuestionsAnswered'], 'Number');
            }
            if (data.hasOwnProperty('totalCorrectAnswers')) {
                obj['totalCorrectAnswers'] = ApiClient.convertToType(data['totalCorrectAnswers'], 'Number');
            }
            if (data.hasOwnProperty('overallAccuracyRate')) {
                obj['overallAccuracyRate'] = ApiClient.convertToType(data['overallAccuracyRate'], 'Number');
            }
            if (data.hasOwnProperty('totalTimeMinutes')) {
                obj['totalTimeMinutes'] = ApiClient.convertToType(data['totalTimeMinutes'], 'Number');
            }
            if (data.hasOwnProperty('firstActivity')) {
                obj['firstActivity'] = ApiClient.convertToType(data['firstActivity'], 'Date');
            }
            if (data.hasOwnProperty('lastActivity')) {
                obj['lastActivity'] = ApiClient.convertToType(data['lastActivity'], 'Date');
            }
            if (data.hasOwnProperty('categoryStatistics')) {
                obj['categoryStatistics'] = ApiClient.convertToType(data['categoryStatistics'], [CategoryStatisticsDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserStatisticsDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserStatisticsDto</code>.
     */
    static validateJSON(data) {
        if (data['categoryStatistics']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['categoryStatistics'])) {
                throw new Error("Expected the field `categoryStatistics` to be an array in the JSON data but got " + data['categoryStatistics']);
            }
            // validate the optional field `categoryStatistics` (array)
            for (const item of data['categoryStatistics']) {
                CategoryStatisticsDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} userId
 */
UserStatisticsDto.prototype['userId'] = undefined;

/**
 * @member {Number} totalSessions
 */
UserStatisticsDto.prototype['totalSessions'] = undefined;

/**
 * @member {Number} completedSessions
 */
UserStatisticsDto.prototype['completedSessions'] = undefined;

/**
 * @member {Number} activeSessions
 */
UserStatisticsDto.prototype['activeSessions'] = undefined;

/**
 * @member {Number} totalPagesVisited
 */
UserStatisticsDto.prototype['totalPagesVisited'] = undefined;

/**
 * @member {Number} totalQuestionsAnswered
 */
UserStatisticsDto.prototype['totalQuestionsAnswered'] = undefined;

/**
 * @member {Number} totalCorrectAnswers
 */
UserStatisticsDto.prototype['totalCorrectAnswers'] = undefined;

/**
 * @member {Number} overallAccuracyRate
 */
UserStatisticsDto.prototype['overallAccuracyRate'] = undefined;

/**
 * @member {Number} totalTimeMinutes
 */
UserStatisticsDto.prototype['totalTimeMinutes'] = undefined;

/**
 * @member {Date} firstActivity
 */
UserStatisticsDto.prototype['firstActivity'] = undefined;

/**
 * @member {Date} lastActivity
 */
UserStatisticsDto.prototype['lastActivity'] = undefined;

/**
 * @member {Array.<module:model/CategoryStatisticsDto>} categoryStatistics
 */
UserStatisticsDto.prototype['categoryStatistics'] = undefined;






export default UserStatisticsDto;

